// TODO: Remove dark theme references everwhere
export const getTheme = () => 'light';
